type Skill = {
  name: string;
  proficiency: number;
};

export const skills: Skill[] = [
  { name: "HTML", proficiency: 95 },
  { name: "GIT", proficiency: 95 },
  { name: "Javascript", proficiency: 90 },
  { name: "jQuery", proficiency: 90 },
  { name: "Bootstrap", proficiency: 90 },
  { name: "Redis", proficiency: 90 },
  { name: "PHP", proficiency: 85 },
  { name: "CSS", proficiency: 85 },
  { name: "TFS", proficiency: 85 },
  { name: "Laravel", proficiency: 80 },
  { name: "ReactJS", proficiency: 80 },
  { name: "MongoDB", proficiency: 80 },
  { name: "Jira", proficiency: 80 },
  { name: "Postman", proficiency: 75 },
  { name: "MariaDB", proficiency: 70 },
];
